import { render } from "./PChatPhotoAdd.vue?vue&type=template&id=d26bcf80"
import script from "./PChatPhotoAdd.vue?vue&type=script&lang=js"
export * from "./PChatPhotoAdd.vue?vue&type=script&lang=js"

import exportComponent from "../../../../node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__